import React from 'react';
import {EOYRemindersView} from './view';
import {useEOYReminders} from './hooks';
import {observer} from 'mobx-react';
import {companyStore} from '../../../../stores/Company/Company.store';
import {EOYReminderStore} from '../../actions/reminders';
import {EOYPromo} from '../Promo/EOYPromo';

export const EndOfYearReminders = observer((props, ref) => {
    const currentCompany = companyStore.currentCompany;
    const {showReminder, showPromo} = EOYReminderStore;
    const data = useEOYReminders(currentCompany);
    const {
        stages,
        activeStageIndex,
        reminderType,
        lastUnfinishedStep,
        stepTitle,
        prevStep,
        onClose,
        stepAssignByFullName,
        prevStepFullUserName
    } = data;

    if (showPromo) {
        return <EOYPromo />;
    } else if (showReminder) {
        return (
            <EOYRemindersView
                lastUnfinishedStep={lastUnfinishedStep}
                stepTitle={stepTitle}
                onClose={onClose}
                stages={stages}
                reminderType={reminderType}
                activeStageIndex={activeStageIndex}
                prevStepTitle={prevStep}
                stepAssignByFullName={stepAssignByFullName}
                prevStepFullUserName={prevStepFullUserName}
            />
        );
    } else {
        return null;
    }
});
